import { Component, Inject, Input, OnDestroy } from "@angular/core";

import { OnInit } from "@angular/core";

import { FieldGeneratorService } from "../../services/field-generator.service";
import { MatDialog, fadeInItems } from "@angular/material";

import { FormDialogComponent } from '../form-dialog/form-dialog.component';
import { MessageService } from '../../services/message.service';
import { EventBusService } from '../../services/event-bus.service';
import { GlobalCfgService } from '../../services/globalcfg.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/services/auth.service';
import { ConfirmationDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ChainNodeComponent } from './node/node.component';
import { Utils } from 'src/services/utils';
import { MiscService } from 'src/services/misc.service';
import { AlertComponent } from '../alert/alert.component';

@Component({
  selector: "rm-manage-chain",
  templateUrl: "./manage-chain.component.html",
  styleUrls: ["./manage-chain.component.css"]
})
export class ManageChainComponent implements OnInit, OnDestroy {

  role: any;
  length: number = 0;
  loaded: boolean = true;

  // data: any[] = [{
  //   title: 'Chain 1',
  //   participants: [{
  //     name: 'brand-owner',
  //     description: 'Brand Owner'
  //   }, {
  //     name: 'distributor',
  //     description: 'Distributor'
  //   }, {
  //     name: 'patient',
  //     description: 'Consumer'
  //   }]
  // }];
  data: any[] = [];
  gcp: string;
  subscriptions: any[] = [];

  selectedChianIdx: any;
  selectedIdx: any;
  
  constructor(
    private dialog: MatDialog,
    private fgService: FieldGeneratorService,
    private authService: AuthService,
    private ebService: EventBusService,
    private msgService: MessageService,
    private globalCfgService: GlobalCfgService,
    private route: ActivatedRoute,
    private utils: Utils,
    private miscService: MiscService
  ) {}

  ngOnInit() {
    this.gcp = this.globalCfgService.getGcp();

    this.load(this.gcp);

    this.subscriptions.push(this.ebService.particpantSelectionFetchedValue$.subscribe(
      (gcp) => {
        this.gcp = gcp;
        this.load(this.gcp);
      }
    ));

    this.route.parent.url.subscribe(url => {
      //always the first part is role
      this.role = url.values().next().value.path;
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  addChain() {
    this.gcp = this.globalCfgService.getGcp();
    if (!this.gcp) {
      const dialogRef = this.dialog.open(AlertComponent, {
        width: "450px",
        data: { 
          title: "Add Chain",
          note: "Select an organisation and try again",
        },
      });

      return;
    }

    var fields = this.fgService.getFields([{name: 'name', description: 'Chain Name'}], {});


    const dialogRef = this.dialog.open(FormDialogComponent, {
      width: "450px",
      data: { 
        title: "Add Chain",
        fields: fields
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("The dialog was closed", result);
      if (!result) {
        return;
      }

      this.miscService.addChain({
        gcp: this.gcp,
        title: result.name
      }).subscribe(
        ()=> {
          this.msgService.showSuccess(this.msgService.chainCreate);
          this.load(this.gcp);
        }
      );
    });

  }

  updateChain(rec, isActive) {
    rec["isActive"] = isActive
    this.miscService.updateChain(rec).subscribe(
      () => {
        if (isActive) {
          this.msgService.showSuccess(this.msgService.chainActivate);
        } else {
          this.msgService.showSuccess(this.msgService.chainDeactivate);
        }
        this.load(this.gcp);
      }
    )
  }

  deleteChain(rec) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '450px',
      data: {
          message: 'Are you sure you want to delete this chain?'
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'yes') {
        this.miscService.deleteChain(rec.id).subscribe(
          () => {
            this.msgService.showSuccess(this.msgService.chainDelete);
            this.load(this.gcp);
          }
        );
      }
    });
  }
  
  addParticipant(i) {
    this.gcp = this.globalCfgService.getGcp();
    if (!this.gcp) {
      alert('Select a brand and continue');
      return;
    }

    const dialogRef = this.dialog.open(ChainNodeComponent, {
      width: "450px",
      data: { 
        title: "Add Participant",
        addedRoles: this.data.length > 0 ? this.data[i].participants : []
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("The dialog was closed", result);
      if (!result) {
        return;
      }

      var idx = result.addAfter;
      var chainId = this.data[i].id;

      this.miscService.addParticipantToChain({
        seq: idx,
        roleId: result.role.id,
        chainId: chainId
      }).subscribe(
        ()=> {
          this.msgService.showSuccess(this.msgService.participantCreate);
          this.load(this.gcp);
        }
      );

      // var idx = this.utils.getIdx('seq', result.addAfter, this.data[0].participants);
      // var idx = result.addAfter;
      // this.data[0].participants.splice(idx, 0, result.role);



    });

  }

  load(gcp) {
    this.miscService.getChains(gcp).subscribe(
      (result: any) => {
        console.log("load chains: ", result.data);
        this.data = result.data;
        this.length = result.count;
      }
    );
  }

  editParticipant(e, rec, data, i, pIdx) {
    if(this.role !== "admin") {
      return;
    }
    console.log("edit event: ", rec);
    // e.currentTarget.className += ' red';
    const dialogRef = this.dialog.open(ChainNodeComponent, {
      width: "450px",
      data: { 
        title: "Edit Participant",
        addedRoles: this.data.length > 0 ? this.data[i].participants : [],
        data: {
          selectedRole: rec.role.name,
          previousRole: pIdx == 0 ? "0" : pIdx
        }
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("The dialog was closed", result);
      if (!result) {
        return;
      }

      const toEditParticipant = {
        chainId: rec.chainId,
        id: rec.id,
        roleId: result.role.id,
        seq: result.addAfter
      };

      this.miscService.updateParticipantInChain(toEditParticipant).subscribe(
        ()=> {
          this.msgService.showSuccess(this.msgService.participantUpdate);
          this.load(this.gcp);
        }
      );
    });
  }

  deleteParticipant(pSeq, data) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '450px',
      data: {
          message: 'Are you sure you want to remove participant from the chain?'
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'yes') {
        var participants: any[] = data.participants.filter(x => x.seq !== pSeq);
        for (var i = 0; i < participants.length; i++) {
          var p = participants[i];
          if (p.seq > pSeq) {
            p["seq"] -= 1;
          }
        }
        var rec = [];

        this.miscService.deleteChain(data.id).subscribe(
          () => {
            // after successfully deleting chain, recreate chain
            this.miscService.addChain({
              gcp: this.gcp,
              title: data.title
            }).subscribe(
              (result)=> {
                participants.forEach(ele => {
                  rec.push({
                    seq: ele.seq,
                    roleId: ele.roleId,
                    chainId: result["id"]
                  })
                });
                // after successfully creating chain, add list of participants
                this.miscService.addParticipantToChain(rec).subscribe(
                  ()=> {
                    this.msgService.showSuccess(this.msgService.participantDelete);
                    this.load(this.gcp);
                  }
                );
              }
            );
          }
        );
      }
    });
  }

  mouseenter(e, chainIdx, participantIdx) {
    // e.currentTarget.className += ' red';
    this.selectedChianIdx = chainIdx;
    this.selectedIdx = participantIdx;
  }

  mouseleave(e) {
    // e.target.classList.remove('red');
    this.selectedIdx = null;
  }
  
}
